import naja from "naja";

export default class LoginRegisterModalExtension {
	constructor(naja) {
		naja.addEventListener('init', this.assistant.bind(this));
	}

	assistant() {
		let self = this;
		let showModalElement = self.getModalElement('#fn_modal-login');

		document.addEventListener('click', function (e) {
			if (e.target !== null && e.target.hasAttribute('data-open-login')) {
				e.preventDefault();
				let modalElement = self.getModalElement(e.target.getAttribute('data-open-login'));
				var loginLink = document.querySelector('#fn_login-link').getAttribute('data-link');
				var isCurrentLogin = document.querySelector('#fn_login-form-shown') !== null;

				self.processModal(showModalElement, modalElement, isCurrentLogin, loginLink);
			}

			if (e.target !== null && e.target.hasAttribute('data-open-register')) {
				e.preventDefault();
				let modalElement = self.getModalElement(e.target.getAttribute('data-open-register'));
				var registerLink = document.querySelector('#fn_register-link').getAttribute('data-link');

				var isCurrentRegister = document.querySelector('#fn_conditions') !== null;

				self.processModal(showModalElement, modalElement, isCurrentRegister, registerLink);
			}

			if (e.target !== null && e.target.hasAttribute('data-open-lost-password')) {
				e.preventDefault();
				let modalElement = self.getModalElement(e.target.getAttribute('data-open-lost-password'));
				var lostPasswordLink = document.querySelector('#fn_lostPassword-link').getAttribute('data-link');

				var isCurrentLostPassword = document.querySelector('#fn_conditions') !== null;

				self.processModal(showModalElement, modalElement, isCurrentLostPassword, lostPasswordLink);
			}
		});
	}

	processModal(showModalElement, modalElement, isCurrent, link) {
		if (!isCurrent) {
			naja.makeRequest('GET', link).then(function (payload) {
				if (modalElement !== null) {
					let modal = new bs.Modal(modalElement);
					modal.hide();
				}
				let modal = new bs.Modal(showModalElement);
				modal.show();
			})
		} else {
			if (modalElement !== null) {
				let modal = new bs.Modal(modalElement);
				modal.hide();
			}
			let modal = new bs.Modal(showModalElement);
			modal.show();
		}
	}

	getModalElement(modalName) {
		if (!modalName.startsWith('#')) {
			modalName = '#' + modalName;
		}

		if (modalName === '#' || modalName === '') {
			return null;
		}

		return document.querySelector(modalName);
	}
}